import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function TypePromotion({ member }) {
  return (

    <ValueItem
      icon="type-promotion-icon"
      label="Type of Promotion"
    >
      {member.career_histories.find((item) => item.code === 'CUSTOM_CH_Q3')?.answer}
    </ValueItem>
  );
}

TypePromotion.propTypes = {
  member: PropTypes.object.isRequired,
};
